<template>
  <el-button @click="open" type="primary">Xls 上傳</el-button>
</template>

<script>
  import {getToken} from "../api";

  export default {
    name: "XlsUploader",
    methods: {
      open() {
        this.$alert(`<iframe class="upload" src="http://api.taipec.gugame.net/index.php?/upload/xls?TOKEN=${getToken()}"/>`,
          'Xls 上傳', {dangerouslyUseHTMLString: true}
        )
      }
    }
  }
</script>

<style>
  iframe.upload {
    width: 380px;
    height: 200px;
  }
</style>